import { Component, Prop, h, State } from '@stencil/core';
// import { format } from '../../utils/utils';
// import bootstrap from 'bootstrap';




@Component({
  tag: 'my-component',
  styleUrl: 'my-component.css',
  // shadow: true,
   scoped: true
})
export class MyComponent {


  // items = [];


  @Prop() componentid: string;
  @Prop() listname: string;
  @Prop() webpath: string;
  @Prop() sectiontitle: string;
  @Prop() titleiconurl: string;

  @State() items:[]


  componentWillLoad() {

    const url = '//platform.twitter.com/widgets.js';

    // only load script once
    if (!Array.from(document.querySelectorAll('script')).some(elm => elm.id == 'twitter-js')) {
      let script = document.createElement('script');
      script.src = url;
      script.id = 'twitter-js';
      document.getElementsByTagName('head')[0].appendChild(script);
    }
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;
   
    // const filter = "";


    // return fetch(siteUrl + "/" + this.webpath + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,ItemOrder,Url&$filter=" + filter + "&$orderby=ItemOrder", { headers: { "Accept": "application/json; odata=verbose" } })

    //   .then(response => response.json())
    //   .then(data => {
    //     this.items = data.d.results;
    //   });
  }



  render() {
    console.log(this.webpath);

    console.log(this.componentid);
    // let idhash = "#" + this.componentid;
    return <div>
  
      {/* <div class="colSmHeader">
        <img class="icon-image img-fluid, float-start" src={this.titleiconurl} alt="icon image" />
        <div class="colSmTitle">{this.sectiontitle}</div>
      </div>


      <ul class="list-group list-group-flush" style={{borderBottomRightRadius: "10px", borderBottomLeftRadius: "10px"}}>
        {this.items.map((i: any) => <li class="list-group-item"> <a href={i.Url} >{i.Title}</a></li>)}
      </ul> */}

<a href={'//twitter.com/' + "nyphospital"} class="twitter-timeline"></a>;

      {/* 
<div class="accordion" id={this.componentid}>
  <div class="accordion-item">
    
    <h2 class="accordion-header" id={`headingOne${this.componentid}`} >
      <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseOne${this.componentid}`} aria-expanded="true" aria-controls={`collapseOne${this.componentid}`}>
        Accordion Item #1
      </button>
    </h2>
    <div id={`collapseOne${this.componentid}`} class="accordion-collapse collapse show" aria-labelledby={`headingOne${this.componentid}`} data-bs-parent= {idhash}>
      <div class="accordion-body">
        <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id={`headingTwo${this.componentid}`}>
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseTwo${this.componentid}`} aria-expanded="false" aria-controls={`collapseTwo${this.componentid}`}>
        Accordion Item #2
      </button>
    </h2>
    <div id={`collapseTwo${this.componentid}`} class="accordion-collapse collapse" aria-labelledby={`headingTwo${this.componentid}`} data-bs-parent={idhash}>
      <div class="accordion-body">
        <strong>This is the second item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
  <div class="accordion-item">
    <h2 class="accordion-header" id={`headingThree${this.componentid}`}>
      <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseThree${this.componentid}`} aria-expanded="false" aria-controls={`collapseThree${this.componentid}`}>
        Accordion Item #3
      </button>
    </h2>
    <div id={`collapseThree${this.componentid}`} class="accordion-collapse collapse" aria-labelledby={`headingThree${this.componentid}`} data-bs-parent={idhash}>
      <div class="accordion-body">
        <strong>This is the third item's accordion body.</strong> It is hidden by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
      </div>
    </div>
  </div>
</div> */}




    </div>;
  }
}
